import React from "react";
import { Card, Alert } from "react-bootstrap";

function RunbooksOverview() {
  return (
    <div>
      <h2 className="mb-4">Runbooks Overview</h2>

      <Alert variant="info">
        Runbooks are automated workflows that perform tasks, integrate with external systems, and process data.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>What is a Runbook?</h4>
          <p>
            A runbook is a collection of steps that execute in sequence to accomplish a specific task or workflow.
            Think of it as a recipe that the system follows to complete a job automatically.
          </p>
          <p>
            Runbooks can:
          </p>
          <ul>
            <li>Connect to external systems using connectors</li>
            <li>Read and write data using variables</li>
            <li>Make decisions based on conditions</li>
            <li>Loop through data sets</li>
            <li>Send notifications via email</li>
            <li>Process and transform data</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Viewing Your Runbooks</h4>
          <ol>
            <li>Click <strong>My Runbooks</strong> in the left menu</li>
            <li>You'll see a grid displaying all available runbooks</li>
            <li>Use the filter panel to search by runbook name, category, or status</li>
            <li>Click on any runbook row to select it and see available actions</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Runbook Information</h4>
          <p>Each runbook displays the following information:</p>
          <ul>
            <li><strong>Name</strong> - The runbook's identifier</li>
            <li><strong>Description</strong> - What the runbook does</li>
            <li><strong>Category</strong> - Organizational grouping</li>
            <li><strong>Last Execution</strong> - When it was last run</li>
            <li><strong>Next Execution</strong> - When it's scheduled to run next (if scheduled)</li>
            <li><strong>Status</strong> - Whether the runbook configuration is valid</li>
            <li><strong>Version</strong> - Current version number</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Runbook Actions</h4>
          <p>When you select a runbook, you can perform various actions:</p>
          <ul>
            <li><strong>Execute</strong> - Run the runbook immediately</li>
            <li><strong>Edit</strong> - Modify the runbook's settings or workflow</li>
            <li><strong>Validate</strong> - Check if the runbook configuration is correct</li>
            <li><strong>View History</strong> - See past executions and their results</li>
            <li><strong>Favorite</strong> - Mark as favorite to show on your dashboard</li>
          </ul>
          <p className="mt-3">
            <em>Note: Available actions depend on your user permissions.</em>
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Understanding Validation Status</h4>
          <p>
            Runbooks show a validation status indicator. A valid runbook has all required fields filled in and
            proper configuration. If a runbook is invalid, you'll need to edit it and fix any configuration errors
            before it can be executed.
          </p>
        </Card.Body>
      </Card>
    </div>
  );
}

export default RunbooksOverview;
